import {
  SchedulePreviewAppointment,
  UpcomingAgendaCardConnected,
  UpcomingAgendaErrorCard,
  ProviderEventType,
  useSetCoachConversation,
  CoachConversation,
} from "@grow-therapy-team/seedling-components";
import { ErrorBoundary } from "react-error-boundary";
import { EventTypeEnum } from "../../segment/types";
import { useCallback } from "react";
import { useOpenClientInfoDrawerForAppointment } from "../client-information/useOpenClientInfoDrawerForAppointment";
import { useTrackEvent } from "../../segment/segment";
import { PreVisitSummaryCardNudgeWrapper } from "../client-information/pre-visit-summary/PreVisitSummaryCardNudgeWrapper";
import { useExternalResourceButtonOnClickHandlers } from "../client-information/pre-visit-summary/useExternalResourceButtonOnClickHandlers";

export function UpcomingAgendaWrapper() {
  const { userClicked } = useTrackEvent();
  const openClientInfoDrawerForAppointment =
    useOpenClientInfoDrawerForAppointment();
  const { setCoachConversation } = useSetCoachConversation();
  const createResourceButtonOnClickHandlers =
    useExternalResourceButtonOnClickHandlers;

  const onClickAppointmentTile = useCallback(
    (
      appointmentNode: SchedulePreviewAppointment,
      appointmentPosition: number,
    ) => {
      const appointment = appointmentNode.node;
      openClientInfoDrawerForAppointment(appointment);
      userClicked(EventTypeEnum.WAITING_ROOM_SCHEDULE, {
        appointmentPosition,
        appointmentShortId: appointment?.appointmentShortId,
      });
    },
    [openClientInfoDrawerForAppointment, userClicked],
  );

  const onClickUnreadCoachConversation = useCallback(
    (
      appointment: SchedulePreviewAppointment["node"],
      conversation: CoachConversation,
    ) => {
      openClientInfoDrawerForAppointment(appointment);
      setCoachConversation(conversation);
    },
    [openClientInfoDrawerForAppointment, setCoachConversation],
  );

  return (
    <ErrorBoundary
      FallbackComponent={() => (
        <UpcomingAgendaErrorCard cardClassName="max-h-[80%] sm:w-[40rem] w-full flex flex-col overflow-auto" />
      )}
    >
      <UpcomingAgendaCardConnected
        onClickAppointmentTile={onClickAppointmentTile}
        preVisitSummaryProviderViewEventType={
          ProviderEventType.VIEWED_PRE_VISIT_SUMMARY_NO_MEDICAL_RECORD_UPCOMING_APPOINTMENT_TELEHEALTH
        }
        cardClassName="max-h-[80%] sm:w-[40rem] w-full flex flex-col overflow-auto"
        preVisitSummaryNudgeContext="telehealth-waiting-room"
        preVisitSummaryCardComponent={PreVisitSummaryCardNudgeWrapper}
        preVisitSummaryOnClickUnreadCoachConversation={
          onClickUnreadCoachConversation
        }
        createResourceButtonOnClickHandlers={
          createResourceButtonOnClickHandlers
        }
      />
    </ErrorBoundary>
  );
}
